import * as React from "react";
import {IReadOrganizationResponse} from "../../core/api/organization/response/ReadOrganizationResponse";

interface IProps {
    data: IReadOrganizationResponse;
}

interface IState {
    menuItem: {}
}

export class VillageOrgGridItem extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            menuItem: {}
        }
    }

    public render() {
        return (
            <div className="blog-item">
                <div className="pull-right">
                    <a className="btn btn-mod btn-round btn-small" href={'/organisasi-desa/' + this.props.data.slug}>Detail</a>
                </div>
                <div className="blog-item-date">
                    <img src={this.props.data.documentationImage} />
                </div>
                <h2 className="blog-item-title font-alt">
                    <a href={'/organisasi-desa/' + this.props.data.slug}>{this.props.data.name}</a>
                </h2>
                <div className="blog-item-data">
                    <a href={'/organisasi-desa/' + this.props.data.slug}><i className="fa fa-user" /> {this.props.data.leader}</a>
                </div>
                <hr />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/village-organization/VillageOrgGridItem.tsx